import uniqBy from 'lodash/uniqBy';
import { DocumentGroup } from '../../../../../interfaces/DocumentGroup';

export const selectContracts = (documentGroups: DocumentGroup[]) => {
  const receivedContracts = documentGroups.flatMap((g) => g.documents.map((d) => d.contract));
  return uniqBy(receivedContracts, 'contractNumber');
};
